import {
  BlueBirdTheme,
  Button, Modal, ModalContentBody, ModalContentHead, ModalContentWrapper, ModalFooter, Typography,
} from "@kitbird/core";
import { ComponentPropsWithoutRef } from "react";
import styled from "styled-components";

interface ModalBodyProps extends ComponentPropsWithoutRef<typeof ModalContentBody> {
  $maxHeight?: string;
  $overFlowY?: string;
}

const StyledModalContentBody = styled(ModalContentBody) <ModalBodyProps>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: ${({ $maxHeight = "617px" }) => $maxHeight};
  overflow-y: ${({ $overFlowY = "auto" }) => $overFlowY};
`;

interface ModalConfirmationProps {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string | React.ReactNode;
  action?: {
    negativeBtn: {
      show: boolean;
      onClick: () => void;
      label: string;
    }
    positiveBtn: {
      show: boolean;
      onClick: () => void;
      label: string;
      destructive: boolean;
      variant?: "text" | "primary" | "secondary" | "tertiary";
    }
  }
  width?: number
}

const ModalConfirmation = ({
  open,
  onClose,
  title,
  message,
  action,
  width = 617,
}: ModalConfirmationProps) => (
  <Modal open={open} onClose={onClose} width={width}>
    <ModalContentWrapper>
      <ModalContentHead title={title} onClose={onClose} />
      <StyledModalContentBody>
        {typeof message === "string" ? <Typography level={6} fontWeight="medium">{message}</Typography> : message}
      </StyledModalContentBody>
      {action && (
        <ModalFooter>
          {action.negativeBtn.show && (
            <Button
              variant="text"
              onClick={action.negativeBtn.onClick}
              type="button"
            >
              {action.negativeBtn.label}
            </Button>
          )}
          {action.positiveBtn.show && (
            <Button
              variant={action.positiveBtn.variant}
              color={BlueBirdTheme.colors.white}
              backgroundColor={action.positiveBtn.destructive
                ? BlueBirdTheme.colors.danger[500]
                : BlueBirdTheme.colors.primary[500]
              }
              onClick={action.positiveBtn.onClick}
              type="button"
            >
              {action.positiveBtn.label}
            </Button>
          )}
        </ModalFooter>
      )}
    </ModalContentWrapper>
  </Modal>
);

export default ModalConfirmation;
